import { AppState } from "../..";

export const getSurvey = (state: AppState) => state.survey;
export const getSurveyDetails = (state: AppState) => state.survey.details;
